module.exports = __webpack_public_path__ + "static/media/listing-page-generic.7bf35b41.webp";